module.exports = __webpack_public_path__ + "img/creditdebt.284ba948.jpg";